import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import {
  List,
  ListItem,
  withStyles,
  ListItemText,
  ListSubheader,
} from '@material-ui/core'

import Automation from './Automation'


const styles = theme => ({
  root: {
    marginTop: theme.spacing(2),
  },
})


class ListAutomation extends PureComponent {
  /* METHODS */

  /**
   * On click on an item
   * @param {*} item - The item selected
   */
  handleClick = (item) => (e) => {
    const { onClick } = this.props

    if (onClick) {
      onClick(item, e)
    }
  }


  /* RENDER */

  /**
   * @render
   * @returns {JSX}
   */
  render() {
    const {
      row,
      items,
      title,
      onClick,
      className,
      ...props
    } = this.props

    return (
      <Automation
        {...props}
        row={row}
        items={items}
      >
        <List className={className}>
          {title && <ListSubheader>{title}</ListSubheader>}
          {items.map((item) => {
            const { primary, secondary } = row(item)

            return (
              <ListItem
                key={item.id}
                button={!!onClick}
                onClick={this.handleClick(item)}
              >
                <ListItemText primary={primary} secondary={secondary} />
              </ListItem>
            )
          })}
        </List>
      </Automation>
    )
  }
}


ListAutomation.defaultProps = {
  items: [],
}


ListAutomation.propTypes = {
  row: PropTypes.func,
  title: PropTypes.string,
  onClick: PropTypes.func,
  csvTitle: PropTypes.string,
  className: PropTypes.string,
  paperClassName: PropTypes.string,
  request: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  items: PropTypes.arrayOf(PropTypes.object),
}


export default withStyles(styles)(ListAutomation)
